export default "__VITE_ASSET__DkH0ogtS__"